// 9fbef606107a605d69c0edbcd8029e5d

export const SLP_SUB_LABELS = 'SLPs.SLPs_Sub';
export const lbl404HeadingTcp = 'lbl_404_heading_tcp';
export const lbl404SubHeaderTcp = 'lbl_404_sub_header_tcp';
export const lblBrierleyPromoTextGeneric = 'lbl_brierley_promo_text_generic';
export const lblBrowseProductCategory = 'lbl_browse_product_category';
export const lblCategoryMatches = 'lbl_category_matches';
export const lblCheckSpelling = 'lbl_check_spelling';
export const lblCheckYourSpelling = 'lbl_check_your_spelling';
export const lblClearRecentSearch = 'lbl_clear_recent_search';
export const lblDidYouMean = 'lbl_didYouMean';
export const lblLookingFor = 'lbl_looking_for';
export const lblNarrowSearches = 'lbl_narrow_searches';
export const lblNoSuggestion = 'lbl_no_suggestion';
export const lblNoresultsFound = 'lbl_noresults_found';
export const lblNoresultsFoundFor = 'lbl_noresults_found_for';
export const lblNothingMatched = 'lbl_nothing_matched';
export const lblRecentlyViewed = 'lbl_recently_viewed';
export const lblResult = 'lbl_result';
export const lblResults = 'lbl_results';
export const lblSearchInstead = 'lbl_search_instead';
export const lblSearchLookingFor = 'lbl_search_looking_for';
export const lblSearchProductMatches = 'lbl_search_product_matches';
export const lblSearchRecentSearch = 'lbl_search_recent_search';
export const lblSearchWhatsTrending = 'lbl_search_whats_trending';
export const lblSearchedFor = 'lbl_searched_for';
export const lblShopThisStoreSearchInstead = 'lbl_shopThisStore_searchInstead';
export const lblShowingResultsFromOurOtherBrands = 'lbl_showing_results_from_our_other_brands';
export const lblSimplifiedKeywords = 'lbl_simplified_keywords';
export const lblTips = 'lbl_tips';
export const lblTryBetterResults = 'lbl_try_better_results';
export const lblTryReducingSearch = 'lbl_try_reducing_search';
export const lblTrySearching = 'lbl_try_searching';
export const lblYouMayAlsoLike = 'lbl_you_may_also_like';
export const lblFeatureBrandResultsFor = 'lbl_feature_brand_results_for';

export const slpSubLabels = {
  SLPs: {
    SLPs_Sub: {
      lbl_showing_x_items: 'Showing',
      lbl_items: 'Items',
      lbl_item: 'Item',
      lbl_range_of: 'of',
      lbl_view_all: 'View all',
      lbl_featured_products: 'FEATURED PRODUCTS',
      lbl_trending_searches: 'TRENDING SEARCHES',
      lbl_previous_searches: 'PREVIOUS SEARCHES',
      [lbl404HeadingTcp]: 'Check out these similar styles \t',
      [lbl404SubHeaderTcp]: 'Sorry, the page you were looking for is unavailable…',
      [lblBrierleyPromoTextGeneric]: '2X POINTS## or ##3X POINTS',
      [lblBrowseProductCategory]: 'Browse through the product category',
      [lblCategoryMatches]: 'CATEGORY MATCHES',
      [lblCheckSpelling]: 'Check for spelling mistakes',
      [lblCheckYourSpelling]: 'Check your spelling ',
      [lblClearRecentSearch]: 'CLEAR ALL',
      [lblDidYouMean]: 'Did you mean ',
      [lblLookingFor]: 'What are you looking for? ',
      [lblNarrowSearches]: 'Try broader searches and then narrow your results ',
      [lblNoSuggestion]: 'No Suggestions Found',
      [lblNoresultsFound]: 'No Results Found',
      [lblNoresultsFoundFor]: 'No results found for',
      [lblNothingMatched]: 'Nothing matched your search for ',
      [lblRecentlyViewed]: 'RECENTLY VIEWED',
      [lblResult]: 'result',
      [lblResults]: 'results',
      [lblSearchInstead]: 'Instead search for',
      [lblSearchLookingFor]: "I'M LOOKING FOR",
      [lblSearchProductMatches]: 'TOP MATCHING PRODUCTS ',
      [lblSearchRecentSearch]: 'RECENTLY SEARCHED',
      [lblSearchWhatsTrending]: "WHAT'S TRENDING",
      [lblSearchedFor]: 'You searched for ',
      [lblShopThisStoreSearchInstead]: 'Search instead for',
      [lblShowingResultsFromOurOtherBrands]: 'Showing results from our other brands',
      [lblSimplifiedKeywords]: 'Use simplified keywords (jeans, tee, top, hat, dress) ',
      [lblTips]: 'Tips for Searching ',
      [lblTryBetterResults]: 'Get better results by',
      [lblTryReducingSearch]: 'Try reducing the number of keywords searched for',
      [lblTrySearching]:
        'Try searching by themes\\/categories (dinosaur, active, uniform, pj set) ',
      [lblYouMayAlsoLike]: 'YOU MAY ALSO LIKE ',
      [lblFeatureBrandResultsFor]: 'Results for ',
    },
  },
};
